<template>
  <div class="plan-details">
    <h1 class="plan-details__title">
      <slot name="title"></slot>
    </h1>
    <div class="plan-details__price">
      <slot name="price"></slot>
    </div>
    <p class="plan-details__desc">
      <slot name="desc"></slot>
    </p>
    <slot name="action"></slot>
  </div>
</template>
<script>
export default {
    name: 'PlanDetailsBase',
}
</script>
<style scoped lang="scss">
.plan-details {
    &__title {
        color:#00053D;
        font-size: 22px;
        font-style: normal;
        font-weight: 700;
        line-height: 150%;
    }

    &__price {
        margin-top: 4px;
    }

    &__desc {
        color: #00053D;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        margin: 16px 0;
    }
}
</style>